// extracted by mini-css-extract-plugin
module.exports = {"content":"GeneralInfos_content__uwmLL","items":"GeneralInfos_items__0zVMN"};